<template>
  <div class="box-sizing add_control">
    <div class="add_control_position add_control_position_new">
      <div class="el-scrollbar">
        <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
          <div class="el-scrollbar__div">
            <div class="add_btn_list">
              <div class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">通用设置</div>
                  </div>
                </div>
                <div class="setting-item-right"></div>
              </div>
              <div class="switch-div">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">显示创建人信息</div>
                    <div class="demoButton" @click.stop="handleShowCreator">
                      演示
                      <div class="setting-icon"></div>
                    </div>
                  </div>
                </div>
                <el-switch
                  v-model="dataObj.ifShowCreator"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  @change="handleIfShowCreatorChange"
                >
                </el-switch>
              </div>
              <div v-if="dataObj.ifShowCreator == '1'" class="switch-div">
                <p>发布人</p>
                <el-input
                  v-model="dataObj.creatorName"
                  size="small"
                  placeholder="请输入发布人"
                  style="width: 120px; font-size: 14px"
                ></el-input>
              </div>
              <div class="switch-div">
                <p>显示参加人数</p>
                <el-switch
                  v-model="dataObj.ifShowParticipation"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>每人只能回答一次(仅限小程序生效)</p>
                <el-switch
                  v-model="dataObj.ifOneChance"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div v-if="type === 2" class="switch-div">
                <p>显示创建时间</p>
                <el-switch
                  v-model="dataObj.ifShowCreateTime"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>仅创建人可分享</p>
                <el-switch
                  v-model="dataObj.ifShare"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>匿名答题</p>
                <el-switch
                  v-model="dataObj.ifAnonymous"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>题目顺序随机</p>
                <el-switch
                  v-model="dataObj.ifRandomOrder"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>随机选题</p>
                <div class="setting-item-right">
                  <div
                    style="position: relative; z-index: 2"
                    :style="{
                      right: dataObj.ifRandomQuestions === '1' ? '120px' : '0',
                    }"
                  ></div>
                  <div>
                    <el-switch
                      v-model="dataObj.ifRandomQuestions"
                      active-color="#13ce66"
                      inactive-color="#DCDFE6"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <div
                    v-if="dataObj.ifRandomQuestions === '1'"
                    :style="{
                      opacity: dataObj.ifRandomQuestions === '1' ? '1' : '0',
                    }"
                    style="display: flex; align-items: center"
                    @click.stop="handleRandomQuestions"
                  >
                    <div class="setting-link">设置</div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                      mode="heightFix"
                      style="height: 12px"
                    />
                  </div>
                </div>
              </div>
              <div class="switch-div">
                <p>去除问卷底部logo</p>
                <el-switch
                  v-model="dataObj.ifShowFooterLogo"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'0'"
                  :inactive-value="'1'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>可查看已填内容</p>
                <el-switch
                  v-model="dataObj.ifViewContent"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'0'"
                  :inactive-value="'1'"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>
                  免广告<span
                    style="color: #3a60ff; font-size: 13px; margin-left: 5px"
                    >剩余次数：{{ freeAdTimes || 0 }}</span
                  >
                </p>
                <div style="display: flex; align-items: center">
                  <p
                    style="color: #3a60ff; font-size: 13px; cursor: pointer"
                    @click="purchaseFrequency"
                  >
                    购买次数
                  </p>
                  <el-switch
                    v-model="dataObj.ifFreeAd"
                    active-color="#13ce66"
                    inactive-color="#DCDFE6"
                    :active-value="'1'"
                    :inactive-value="'0'"
                  >
                  </el-switch>
                </div>
              </div>
              <div class="switch-div">
                <p>禁止切屏</p>
                <el-switch
                  v-model="dataObj.ifAllowSwitchScreen"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div
                v-if="dataObj.ifAllowSwitchScreen === '1'"
                style="margin-top: 10px; display: flex; align-items: center"
              >
                <p class="allow-times-text">
                  答题时，可切屏<el-input-number
                    v-model="dataObj.allowSwitchScreenTimes"
                    :step="1"
                    :min="0"
                    :max="10"
                    size="mini"
                    style="margin: 0 5px"
                  ></el-input-number
                  >次，超过切屏次数，系统自动交卷
                </p>
              </div>
              <div class="switch-div">
                <p>一页一题</p>
                <el-switch
                  v-model="dataObj.isPage"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleIsPage"
                >
                </el-switch>
              </div>
              <div class="switch-div">
                <p>问卷消息通知</p>
                <el-switch
                  v-model="dataObj.ifMessageNotify"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  @change="handleMessageNotify"
                >
                </el-switch>
              </div>

              <div class="switch-div">
                <p>提交后跳转到指定页</p>
                <el-switch
                  v-model="dataObj.ifRedirect"
                  activeColor="#59D27B"
                  :activeValue="'1'"
                  :inactiveValue="'0'"
                >
                </el-switch>
              </div>
              <div v-if="dataObj.ifRedirect === '1'" class="allow-times-input">
                <div>
                  <input
                    type="text"
                    v-model="dataObj.redirectUrl"
                    placeholder="请输入网页链接地址（网站需ICP备案）"
                    placeholder-class="operateInput"
                    style="width: 100%"
                  />
                </div>
              </div>

              <div class="switch-div">
                <p>控制提交答案总数</p>
                <el-switch
                  v-model="dataObj.ifLimitAnswerNum"
                  activeColor="#59D27B"
                  :activeValue="'1'"
                  :inactiveValue="'0'"
                >
                </el-switch>
              </div>
              <div
                v-if="dataObj.ifLimitAnswerNum === '1'"
                class="allow-times-input special"
              >
                答案总数不超过
                <div>
                  <input
                    type="number"
                    v-model="dataObj.limitAnswerNum"
                    placeholder="请输入"
                    placeholder-class="operateInput"
                    style="width: 100%"
                  />
                </div>
                份。（达到数量自动结束问卷）
              </div>
              <div v-if="type === 2" class="switch-div">
                <p>考试时长</p>
                <div
                  style="display: flex; align-items: center; cursor: pointer"
                  @click.stop="handleExamTimes"
                >
                  <div class="setting-link">
                    {{
                      dataObj.examDuration === 0
                        ? "不限制"
                        : dataObj.examDuration + "分钟"
                    }}
                  </div>
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                    mode="heightFix"
                    style="height: 12px"
                  />
                </div>
              </div>
              <div v-if="type === 2" class="switch-div">
                <p>显示排行榜</p>
                <el-switch
                  v-model="dataObj.ifRankingList"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="setting-item" style="border-bottom: none">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">问卷开始结束时间</div>
                  </div>
                </div>
                <div class="setting-item-right"></div>
              </div>
              <div class="block">
                <span class="demonstration">是否设置问卷时间</span>
                <div class="custom-radio-box" style="margin-top: 10px">
                  <el-radio v-model="dataObj.ifForever" :label="'0'"
                    >不限制</el-radio
                  >
                  <el-radio v-model="dataObj.ifForever" :label="'1'"
                    >限制时间</el-radio
                  >
                </div>
              </div>
              <div v-if="dataObj.ifForever == '1'" class="block top">
                <span class="demonstration top">开始时间</span>
                <div class="top">
                  <el-date-picker
                    v-model="dataObj.startTime"
                    type="datetime"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div v-if="dataObj.ifForever == '1'" class="block top">
                <span class="demonstration">结束时间</span>
                <div class="top">
                  <el-date-picker
                    v-model="dataObj.endTime"
                    type="datetime"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </div>
              </div>

              <div class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">知情同意书</div>
                    <div class="demoButton" @click.stop="handleShowConsentForm">
                      演示
                      <div class="setting-icon"></div>
                    </div>
                  </div>
                </div>
                <div class="setting-item-right">
                  <div
                    style="position: relative; z-index: 2"
                    :style="{
                      right: dataObj.consentRequired === '1' ? '120px' : '0',
                    }"
                  ></div>
                  <div>
                    <el-switch
                      v-model="dataObj.consentRequired"
                      active-color="#13ce66"
                      inactive-color="#DCDFE6"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <div
                    v-if="dataObj.consentRequired === '1'"
                    :style="{
                      opacity: dataObj.consentRequired === '1' ? '1' : '0',
                    }"
                    style="display: flex; align-items: center"
                    @click.stop="handleConsentRequired"
                  >
                    <div class="setting-link">设置</div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                      mode="heightFix"
                      style="height: 12px"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">主题设置</div>
                  </div>
                </div>
                <div class="setting-item-right">
                  <div style="position: relative; z-index: 2"></div>
                  <div
                    style="display: flex; align-items: center"
                    @click.stop="handleThemeSetting"
                  >
                    <div class="setting-link">
                      {{
                        dataObj.themeId === "" ||
                        dataObj.themeId === null ||
                        dataObj.themeId === undefined
                          ? "设置"
                          : themeData.mainTitle
                      }}
                    </div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                      mode="heightFix"
                      style="height: 12px"
                    />
                  </div>
                </div>
              </div> -->
              <div class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">封面设置</div>
                  </div>
                </div>
                <div class="setting-item-right">
                  <div
                    style="position: relative; z-index: 2"
                    :style="{
                      right: dataObj.ifFrontPage === '1' ? '120px' : '0',
                    }"
                  ></div>
                  <div>
                    <el-switch
                      v-model="dataObj.ifFrontPage"
                      active-color="#13ce66"
                      inactive-color="#DCDFE6"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <div
                    v-if="dataObj.ifFrontPage === '1'"
                    :style="{
                      opacity: dataObj.ifFrontPage === '1' ? '1' : '0',
                    }"
                    style="display: flex; align-items: center"
                    @click.stop="handleCoverSetting"
                  >
                    <div class="setting-link">设置</div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                      mode="heightFix"
                      style="height: 12px"
                    />
                  </div>
                </div>
              </div>
              <div class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">独立登录</div>
                    <div class="demoButton" @click.stop="handleShowLogin">
                      演示
                      <div class="setting-icon"></div>
                    </div>
                  </div>
                </div>
                <div class="setting-item-right">
                  <div
                    style="position: relative; z-index: 2"
                    :style="{
                      right: dataObj.ifCustomLogin === '1' ? '120px' : '0',
                    }"
                  ></div>
                  <div>
                    <el-switch
                      v-model="dataObj.ifCustomLogin"
                      active-color="#13ce66"
                      inactive-color="#DCDFE6"
                      :active-value="'1'"
                      :inactive-value="'0'"
                      @change="handleCustomLoginSwitch"
                    >
                    </el-switch>
                  </div>
                  <div
                    v-if="dataObj.ifCustomLogin === '1'"
                    :style="{
                      opacity: dataObj.ifCustomLogin === '1' ? '1' : '0',
                    }"
                    style="display: flex; align-items: center"
                    @click.stop="handleLoginSetting"
                  >
                    <div class="setting-link">设置</div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                      mode="heightFix"
                      style="height: 12px"
                    />
                  </div>
                </div>
              </div>
              <div class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">分享图设置</div>
                    <div
                      class="demoButton"
                      @click.stop="handleShowShareDemoPopup"
                    >
                      演示
                      <div class="setting-icon"></div>
                    </div>
                  </div>
                </div>
                <div class="setting-item-right">
                  <div
                    style="display: flex; align-items: center"
                    @click.stop="handleShareImage"
                  >
                    <img
                      :src="dataObj.shareImgUrl"
                      style="margin-right: 10px; width: 37px; height: auto"
                    />
                    <div class="setting-link">更换</div>
                  </div>
                </div>
              </div>
              <div v-if="type === 3" class="setting-item">
                <div class="setting-item-left">
                  <div style="display: flex; align-items: center">
                    <div class="bar-view"></div>
                    <div class="setting-title">设置测评结果</div>
                    <div
                      class="demoButton"
                      @click.stop="handleShowEvaluationResults"
                    >
                      演示
                      <div class="setting-icon"></div>
                    </div>
                  </div>
                </div>
                <div class="setting-item-right">
                  <div
                    style="position: relative; z-index: 2"
                    :style="{
                      right: dataObj.ifCustomLogin === '1' ? '120px' : '0',
                    }"
                  ></div>
                  <div>
                    <el-switch
                      v-model="dataObj.ifAssessmentResult"
                      active-color="#13ce66"
                      inactive-color="#DCDFE6"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <div
                    v-if="dataObj.ifAssessmentResult === '1'"
                    :style="{
                      opacity: dataObj.ifAssessmentResult === '1' ? '1' : '0',
                    }"
                    style="display: flex; align-items: center"
                    @click.stop="handleSettingEvaluationResult"
                  >
                    <div class="setting-link">设置</div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                      mode="heightFix"
                      style="height: 12px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="drawer-container">
      <el-drawer
        :visible.sync="showThemeSetting"
        :with-header="false"
        :size="500"
      >
        <div
          style="
            width: 500px;
            height: 100%;
            position: relative;
            background-color: #f8f8f8;
          "
        >
          <div class="item-container">
            <div
              v-for="(item, index) in themeList"
              :key="index"
              style="
                width: 102px;
                height: 134px;
                box-sizing: border-box;
                margin-bottom: 15px;
                border-radius: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                cursor: pointer;
              "
              @click.stop="selectThemeIndex = index"
            >
              <div
                style="
                  width: 100%;
                  height: 100%;
                  border-radius: 9px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
                :style="{
                  backgroundImage: `linear-gradient(to bottom, ${item.startColor}, ${item.endColor})`,
                  border: `1px solid ${item.borderColor}`,
                }"
              >
                <div
                  style="
                    display: inline-block;
                    font-size: 18px;
                    font-weight: 700;
                    margin-top: 23px;
                  "
                  :style="{ color: `${item.mainColor}` }"
                >
                  {{ item.mainTitle }}
                </div>
                <div
                  style="
                    display: inline-block;
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: 7px;
                    opacity: 0.7;
                  "
                  :style="{ color: `${item.subColor}` }"
                >
                  {{ item.subTitle }}
                </div>
                <div
                  style="
                    display: inline-block;
                    width: 69px;
                    height: 28px;
                    line-height: 28px;
                    font-size: 15px;
                    margin-top: 18px;
                    border-radius: 4px;
                    border: none;
                    text-align: center;
                  "
                  :style="{
                    border: `1px solid ${item.btnBorder}`,
                    backgroundColor: `${item.btnBg}`,
                    color: `${item.btnColor}`,
                  }"
                >
                  {{ item.btnText }}
                </div>
                <div
                  v-if="selectThemeIndex === index"
                  style="
                    position: absolute;
                    width: 102px;
                    height: 134px;
                    left: 0;
                    top: 0;
                    background-color: rgba(0, 0, 0, 0.56);
                    border-radius: 9px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1747032457200.svg"
                    style="width: 28px; height: 28px; z-index: 10"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="btn-div">
            <div class="cancel" @click.stop="showThemeSetting = false">
              取消
            </div>
            <div class="confirm" @click.stop="themeSettingConfirmClick">
              保存
            </div>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :visible.sync="showLoginSetting"
        :with-header="false"
        :size="500"
      >
        <CustomLogin
          :list="dataObj.customLoginSettingList"
          @custom-login="handleCustomLoginChange"
          @custom-cancel="showLoginSetting = false"
        ></CustomLogin>
      </el-drawer>
      <el-drawer
        :visible.sync="showCoverSetting"
        :with-header="false"
        :size="500"
      >
        <QuestionStartAndEnd
          :dataObj="dataObj"
          @start-end="handleStartEndChange"
          @cancel="showCoverSetting = false"
        ></QuestionStartAndEnd>
      </el-drawer>
      <el-drawer
        :visible.sync="showConsentRequired"
        :with-header="false"
        :size="500"
      >
        <ConsentRequiredDialog
          :content="dataObj.consentContent"
          @confirm="ConsentRequiredContent"
          @cancel="ConsentRequiredClose"
        ></ConsentRequiredDialog>
      </el-drawer>
      <el-drawer
        :visible.sync="showShareImage"
        :with-header="false"
        :size="500"
        @opened="$refs.shareDialog.getList()"
      >
        <ShareImageDialog
          ref="shareDialog"
          :dataObj="dataObj"
          @confirm="ShareImageContent"
          @cancel="ShareImageClose"
        />
      </el-drawer>
      <SettingTimes
        :showDialog="showTimes"
        :time="dataObj.examDuration"
        @confirm="handleTimesConfirm"
        @close="showTimes = false"
      ></SettingTimes>

      <div class="coverShow" v-show="showServiceAccount">
        <div class="container-gj" @click="showServiceAccount = false">
          <div class="container-gd" @click.stop="">
            <div class="bg-view" style="width: 100%">
              <div class="header-view">
                <p>开启消息通知</p>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                  mode=""
                  @click.stop="showServiceAccount = false"
                />
              </div>
              <div class="service-account">
                <img
                  src="https://ossfastmake.mustke.com/wenjuan/tupian/qrcode-1769671129146.jpg"
                  class="qrcode"
                  show-menu-by-longpress="true"
                />
                <p class="text">扫描上方二维码关注服务号</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <my-modal
        :visible.sync="rechargeShow"
        :show-header="false"
        custom-width="340px"
        :show-index="99"
      >
        <div class="rechargeContent flexs">
          <div class="title" style="height: 40px">购买免广告次数</div>
          <img
            src="https://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/wenjuan/tupian/redList.svg"
            class="close"
            @click="rechargeShow = false"
          />

          <div class="tab flexs">
            <div
              class="item flexs"
              v-for="(item, index) in frequencyList"
              :key="item.id"
              :class="{ active: index === activeIndex }"
              @click="onSelect(item, index)"
            >
              <div class="number">{{ item.frequency }}次</div>
              <div class="money">￥{{ item.currentPrice }}</div>
              <div class="originalPrice">￥{{ item.originalPrice }}</div>
              <div class="text">{{ item.discountText }}</div>
            </div>
          </div>
          <div class="description">
            问卷/考试结束页每曝光/或跳过1次，消耗1次免广告次数。广告去除包含：插屏弹窗，题目间隔，Banner形式广告，不包含开屏广告。
          </div>
          <div class="agree-view">
            <el-checkbox v-model="buyAgree"></el-checkbox>
            <span class="agree-text1">我已阅读并同意</span>
            <span class="agree-text2" @click="showBuyAgree = true"
              >《免广告服务购买及使用协议》</span
            >
          </div>
          <div class="button flexs" @click="buyNow">立即购买</div>
        </div>
      </my-modal>

      <!-- <div class="coverShow" v-show="rechargeShow">
        <div class="container-gj" @click="rechargeShow = false">
          <div class="container-gd" style="width: 340px" @click.stop="">
            <div class="rechargeContent flexs">
              <div class="title" style="height: 40px">购买免广告次数</div>
              <img
                src="https://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/wenjuan/tupian/redList.svg"
                class="close"
                @click="rechargeShow = false"
              />

              <div class="tab flexs">
                <div
                  class="item flexs"
                  v-for="(item, index) in frequencyList"
                  :key="item.id"
                  :class="{ active: index === activeIndex }"
                  @click="onSelect(item, index)"
                >
                  <div class="number">{{ item.frequency }}次</div>
                  <div class="money">￥{{ item.currentPrice }}</div>
                  <div class="originalPrice">￥{{ item.originalPrice }}</div>
                  <div class="text">{{ item.discountText }}</div>
                </div>
              </div>
              <div class="description">
                问卷/考试结束页每曝光/或跳过1次，消耗1次免广告次数。广告去除包含：插屏弹窗，题目间隔，Banner形式广告，不包含开屏广告。
              </div>
              <div class="agree-view">
                <el-checkbox v-model="buyAgree"></el-checkbox>
                <span class="agree-text1">我已阅读并同意</span>
                <span class="agree-text2" @click="showBuyAgree = true"
                  >《免广告服务购买及使用协议》</span
                >
              </div>
              <div class="button flexs" @click="buyNow">立即购买</div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="coverShow" v-show="showBuyAgree">
        <div class="container-gj" @click="showBuyAgree = false">
          <div class="container-gd" style="width: 340px" @click.stop="">
            <div class="rechargeContent flexs">
              <div class="title" style="color: #2b2f36; height: 40px">
                免广告服务购买及使用协议
              </div>
              <img
                src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                class="close"
                @click="showBuyAgree = false"
              />
              <div class="agree-content">
                <div class="agree-title">1. 本产品消耗与权益说明</div>
                <div class="agree-desc">
                  消耗规则：问卷/考试结束页每曝光1次或发生跳转1次，系统即视为产生1次展示，自动扣除1次免广告额度。
                </div>
                <div class="agree-desc">
                  广告去除范围：插屏弹窗，题目间隔，Banner形式广告，不包含开屏广告。
                </div>
                <div class="agree-title">2. 售后说明</div>
                <div class="agree-desc">
                  本产品属于虚拟数字化服务，一经购买成功，<span
                    style="color: #f73b42"
                    >除系统故障导致无法使用外，概不支持退换。</span
                  >
                </div>
                <div class="agree-desc">如有疑问，请联系在线客服。</div>
              </div>
              <div class="agree-button flexs" @click="handleIsKnown">
                已知晓
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="Payment" v-if="PaymentShow">
        <div class="content">
          <div class="title">
            支付
            <div
              class="dialogClose"
              @click="(PaymentShow = false), clearPayTimer()"
            ></div>
          </div>
          <div class="region">
            <div class="item">
              应付金额：<span>￥{{ Price }}</span>
            </div>
            <div class="item">订单编号：{{ PaymentData.outTradeNo }}</div>
            <div class="item">有效期：{{ getCurrentTime }} 至无限有效期</div>
          </div>
          <div class="code">
            <img class="brand" src="@/assets/images/123123.jpg" alt="" />
            <img class="image" :src="PaymentData.qrCodeBase64" alt="" />
            <span>用微信扫一扫即可付款</span>
          </div>
        </div>
      </div>

      <SetEvaluationResult
        :show="showSetEvaluationResult"
        :params="{
          uuid: uuid,
          ifShowAssessmentScore: dataObj.ifShowAssessmentScore,
          assessmentResults: dataObj.assessmentResults,
        }"
        @confirm="handleSetEvaluationResultConfirm"
        @close="showSetEvaluationResult = false"
      ></SetEvaluationResult>

      <DemonstratePopup
        :show="showDemonstrate"
        @close="showDemonstrate = false"
        :imgUrl="demonstrateImg"
        :title="demonstrateTitle"
        :btnNum="demonstrateBtnNum"
        @confirm="handleDemonstrateConfirm"
        :demonstrateType="demonstrateType"
        :dataInfo="demonstrateInfo"
      ></DemonstratePopup>

      <div class="coverShow" v-show="showRandomQuestions">
        <div class="container-gj" @click="showRandomQuestions = false">
          <div class="container-gd" style="width: auto" @click.stop>
            <div class="completion-container">
              <div class="bg-view" @click.stop>
                <div class="header-view" @click.stop>
                  <p
                    style="
                      font-size: 18px;
                      font-weight: 600;
                      color: #2b2f36;
                      line-height: 24px;
                    "
                  >
                    随机选题设置
                  </p>
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                    mode=""
                    @click.stop="closeRandomQuestions"
                    style="width: 13px; height: 13px; margin-right: 6px"
                  />
                </div>
                <div class="random-container">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      width: 100%;
                    "
                  >
                    <p>在全部题目中，抽取</p>
                    <div
                      style="
                        flex: 1;
                        padding: 10px;
                        border: 1px solid #e7e7e7;
                        margin: 0 10px;
                        border-radius: 4px;
                      "
                    >
                      <input
                        v-model="this.randomQuestionsNum"
                        placeholder="请输入"
                        @input="randomQuestionsNumChange"
                      />
                    </div>
                    <p>道题进行作答</p>
                  </div>
                  <!-- <p style="line-height: 34px">题进行作答</p> -->
                </div>
                <div class="btn-view">
                  <div class="cancel" @click="closeRandomQuestions">
                    {{ "取消" }}
                  </div>
                  <div class="confirm" @click="randomQuestionsConfirmClick">
                    {{ "确认" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <my-modal :visible.sync="showModal" custom-width="600px">
        这里放你自己的内容
        <div>我是弹窗内容</div>
        <button @click="showModal = false">关闭</button>
      </my-modal> -->
    </div>
  </div>
</template>

<script>
import {
  getThemeList,
  getUserInfo,
  getAdvertisement,
  buyAdCounts,
  getPayment,
  getRemainingBalance,
} from "@/api/index.js";
import config from "@/utils/config";

import CustomLogin from "@/components/CustomLogin/CustomLogin.vue";
import QuestionStartAndEnd from "@/components/QuestionStartAndEnd/QuestionStartAndEnd.vue";
import LibraryChooseDialog from "@/components/LibraryChooseDialog/index.vue";
import ConsentRequiredDialog from "@/components/ConsentRequiredDialog/index.vue";
import ShareImageDialog from "@/components/ShareImageDialog/index.vue";
import SettingTimes from "@/components/SettingTimes/SettingTimes.vue";
import SetEvaluationResult from "@/components/SetEvaluationResult/index.vue";
import DemonstratePopup from "@/components/DemonstratePopup/DemonstratePopup.vue";

import MyModal from "@/components/MyModal/MyModal.vue";

export default {
  name: "AddControl",
  components: {
    CustomLogin,
    QuestionStartAndEnd,
    LibraryChooseDialog,
    ConsentRequiredDialog,
    ShareImageDialog,
    SettingTimes,
    SetEvaluationResult,
    DemonstratePopup,
    MyModal,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1,
    },
    dataList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dataObj: {},
      themeList: [],
      themeData: {},
      selectThemeIndex: 0,
      showCoverSetting: false,
      showLoginSetting: false,
      showConsentRequired: false,
      showShareImage: false,
      showThemeSetting: false,
      showTimes: false,
      showServiceAccount: false,
      showSetEvaluationResult: false,
      rechargeShow: false,
      PaymentShow: false,
      frequencyList: [],
      activeIndex: 0,
      payTimer: null,
      Price: 0,
      PaymentData: {},
      getCurrentTime: "",
      showDemonstrate: false,
      demonstrateImg: "",
      demonstrateTitle: "",
      demonstrateBtnNum: 1,
      demonstrateType: "1",
      demonstrateInfo: {},
      isStopClick: false,
      freeAdTimes: 0,
      showRandomQuestions: false,
      randomQuestionsNum: "",
      buyAgree: false,
      showBuyAgree: false,
    };
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("12312e12e12e12e12e12e12e21e12", newVal);
        this.dataObj = newVal;
        this.themeData = this.dataObj.yzTheme || {};
      },
      deep: true,
      immediate: true,
    },
    dataObj: {
      handler(newVal, oldVal) {
        // this.themeData = newVal.yzTheme || {};
        this.$emit("change", newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getThemeData();
    this.getDefaultFrequency();
  },
  methods: {
    getThemeData() {
      getThemeList()
        .then((res) => {
          this.themeList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDefaultFrequency() {
      getRemainingBalance().then((res) => {
        console.log("1232133ergergergerger23r23r23r23r", res);
        if (res.code === 200) {
          this.freeAdTimes = res.data.freeAdTimes;
        }
      });
    },
    handleIfShowCreatorChange() {
      this.dataObj.ifShowParticipation = this.dataObj.ifShowCreator;
    },
    handleCustomLoginSwitch() {
      console.log(
        "this.dataObj.customLoginSettingList",
        this.dataObj.customLoginSettingList,
      );
      if (this.dataObj.customLoginSettingList.length === 0) {
        this.dataObj.customLoginSettingList = [
          {
            type: 1, // 1题头 2头像 3填空 4下拉
            content: JSON.stringify({
              popTitle: "快速登录",
              popSmallTitle: "请正确填写下面信息",
            }),
          },
          {
            type: 2,
            content: JSON.stringify({
              headTitle: "头像",
              headSmallTitle: "点击上传头像",
              imageUrl:
                "https://ossfastmake.mustke.com/wenjuan/tupian/13-1778757028580.png",
            }),
          },
          {
            type: 3,
            content: JSON.stringify({
              label: "姓名",
              value: "",
              type: 0,
            }),
          },
        ];
      }
    },
    handleConsentRequired() {
      this.showConsentRequired = true;
    },
    ConsentRequiredContent(updatedText) {
      this.dataObj.consentContent = updatedText;
      this.showConsentRequired = false;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    ConsentRequiredClose() {
      this.showConsentRequired = false;
    },
    ShareImageContent(val) {
      this.dataObj.shareImgId = val.shareImgId;
      this.dataObj.shareImgUrl = val.shareImgUrl;
      this.showShareImage = false;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    ShareImageClose() {
      this.showShareImage = false;
    },
    handleThemeSetting() {
      this.showThemeSetting = true;
    },
    themeSettingConfirmClick(e) {
      console.log("e", this.themeList[this.selectThemeIndex]);

      this.showThemeSetting = false;
      this.dataObj.themeId = this.themeList[this.selectThemeIndex].id;
      this.themeData = this.themeList[this.selectThemeIndex];
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    handleCoverSetting() {
      this.showCoverSetting = true;
    },
    handleLoginSetting() {
      this.showLoginSetting = true;
    },

    handleShareImage() {
      this.showShareImage = true;
    },
    handleCustomLoginChange(e) {
      console.log("e", e);
      this.dataObj.customLoginSettingList = JSON.parse(e).info;
      this.dataObj.ifCustomLogin = JSON.parse(e).ifCustomLogin;
      this.showLoginSetting = false;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    handleExamTimes() {
      console.log("dfqwfgfgqwe12e12e12");

      this.showTimes = true;
    },
    handleTimesConfirm(e) {
      console.log(e);
      this.dataObj.examDuration = e;
      this.showTimes = false;
    },
    handleStartEndChange(res) {
      console.log("res", res);
      this.dataObj.startLanguage = res.startLanguage; // 问卷开始语
      this.dataObj.endLanguage = res.endLanguage; // 问卷结束语
      this.dataObj.endImg = res.endImg; // 问卷结束图片
      this.dataObj.startImg = res.startImg; // 问卷开始图片
      this.dataObj.startSubtitle = res.startSubtitle; // 问卷开始小标题
      this.dataObj.startButtonText = res.startButtonText; // 问卷开始按钮文本
      this.dataObj.startButtonColor = res.startButtonColor; // 问卷开始按钮颜色
      this.dataObj.startColor = res.startColor; // 问卷开始主题颜色
      this.dataObj.endColor = res.endColor; // 问卷结束主题颜色
      this.dataObj.endSubtitle = res.endSubtitle; // 问卷结束小标题
      this.dataObj.ifFrontPage = res.ifFrontPage; // 是否开始答题/问卷结束设置 0不设置 1设置
      this.dataObj.startLittleImg = res.startLittleImg; // 问卷开始小图片
      this.dataObj.endLittleImg = res.endLittleImg; // 问卷结束小图片
      this.dataObj.startColorBegin = res.startColorBegin;
      this.dataObj.endColorBegin = res.endColorBegin;
      this.dataObj.startColorEnd = res.startColorEnd;
      this.dataObj.endColorEnd = res.endColorEnd;
      this.dataObj.startThemeColor = res.startThemeColor;
      this.dataObj.endThemeColor = res.endThemeColor;
      this.dataObj.startTextColor = res.startTextColor;
      this.dataObj.endTextColor = res.endTextColor;
      this.showCoverSetting = false;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    handleMessageNotify(val) {
      if (val === "1") {
        getUserInfo(localStorage.getItem("token"))
          .then((res) => {
            console.log("ugfefyuewfywefyey73et72tr7382r", res);

            if (res.code === 200) {
              if (
                this.dataObj.ifMessageNotify === "1" &&
                res.data.officialOpenId === null
              ) {
                this.showServiceAccount = true;
              }
            }
          })
          .catch((err) => {
            console.log(err, "获取用户信息失败");
          });
      }
    },
    handleSettingEvaluationResult() {
      // this.$emit("setting-evaluation-result");
      this.showSetEvaluationResult = true;
    },
    handleSetEvaluationResultConfirm(e) {
      this.dataObj.ifShowAssessmentScore = e.ifShowAssessmentScore;
      this.dataObj.assessmentResults = e.assessmentResults;
      this.showSetEvaluationResult = false;
    },
    handleIsPage(e) {
      const list = JSON.parse(JSON.stringify(this.dataList));
      for (let i = 0; i < list.length; i++) {
        const temp = list[i];
        if (
          temp.type === 1 &&
          temp.logicalJump !== "" &&
          temp.logicalJump !== null &&
          temp.logicalJump !== undefined
        ) {
          // 有逻辑跳转
          setTimeout(() => {
            this.$message({
              type: "error",
              message: "您已设置逻辑跳转，将无法设置一页一题！",
              offset: "150",
            });
          }, 50);
          this.dataObj.isPage = 0;
          return;
        }
        if (temp.type === 34) {
          console.log("ej3hgurgergriuh23rh3r2r23r32", temp);
          setTimeout(() => {
            this.$message({
              type: "error",
              message: "您已添加分页线，将无法设置一页一题！",
              offset: "150",
            });
          }, 50);
          this.dataObj.isPage = 0;
          return;
        }
      }
    },
    purchaseFrequency() {
      getAdvertisement().then((res) => {
        console.log("resqeqwewhgfeqhgweqywfe123r126", res, res.data, res.code);
        if (res.code === 200) {
          this.frequencyList = res.data;
          this.rechargeShow = true;
        }
      });
    },
    onSelect(e, i) {
      this.activeIndex = i;
      console.log("e", e);
    },
    buyNow() {
      if (this.isStopClick) {
        return;
      }
      this.isStopClick = true;
      console.log("fkhf32839yr298ry23ry2389ry2398r8923");

      if (!this.buyAgree) {
        this.$message.warning("请同意《免广告服务购买及使用协议》");
        this.isStopClick = false;
        return;
      }

      buyAdCounts({
        productId: this.frequencyList[this.activeIndex].id,
        quantity: 1,
      })
        .then((res) => {
          // this.$message.success("下单成功");
          this.rechargeShow = false;
          this.PaymentShow = true;
          this.PaymentData = res.data;
          let base64 = this.PaymentData.qrCodeBase64;
          this.PaymentData.qrCodeBase64 = base64.startsWith("data:")
            ? base64
            : "data:image/png;base64," + base64;
          this.Price = this.frequencyList[this.activeIndex].currentPrice;
          this.redStartPolling(res.data.outTradeNo);
          this.getCurrentTime = new Date().toLocaleString();
          this.isStopClick = false;
        })
        .catch((err) => {
          console.log(err, "下单失败", err);
          this.isStopClick = false;
        });
    },
    redStartPolling(outTradeNo) {
      if (this.payTimer) {
        clearInterval(this.payTimer);
        this.payTimer = null;
      }
      if (this.payTimeout) {
        clearTimeout(this.payTimeout);
        this.payTimeout = null;
      }
      this.payTimer = setInterval(async () => {
        try {
          const res = await getPayment({
            outTradeNo,
          });
          console.log("轮询返回", res);
          if (res.data === "SUCCESS") {
            this.clearPayTimer();
            clearInterval(this.payTimer);
            this.payTimer = null;
            clearTimeout(this.payTimeout);
            this.payTimeout = null;

            this.RedEnvelopeDialogVisible = false;
            this.redListShow = false;
            this.redSettingsShow = false;
            this.PaymentShow = false;
            this.$message.success("支付成功");
            this.getData();
          }

          if (res.data === "CLOSED") {
            this.clearPayTimer();
            clearInterval(this.payTimer);
            this.payTimer = null;
            clearTimeout(this.payTimeout);
            this.payTimeout = null;

            this.$message.warning("订单已关闭");
          }
        } catch (err) {
          console.error("查询支付状态失败", err);
        }
      }, 3000);
      this.payTimeout = setTimeout(() => {
        this.clearPayTimer();
        if (this.payTimer) {
          clearInterval(this.payTimer);
          this.payTimer = null;
        }
        // this.RedEnvelopeDialogVisible = false;
        // this.redListShow = false;
        // this.redSettingsShow = false;

        this.PaymentShow = false;
        this.$message.error("支付超时，请重试");
      }, 10 * 60 * 1000);
    },
    clearPayTimer() {
      if (this.payTimer) {
        clearInterval(this.payTimer);
        this.payTimer = null;
      }
      if (this.payTimeout) {
        clearTimeout(this.payTimeout);
        this.payTimeout = null;
      }
    },
    handleShowCreator() {
      this.demonstrateTitle = "显示创建人信息使用演示";
      this.demonstrateBtnNum = 1;
      this.demonstrateType = "显示创建人信息使用演示";
      this.demonstrateImg =
        "https://ossfastmake.mustke.com/qrCode/tupian/1755590818934.jpg";
      this.showDemonstrate = true;
    },
    handleShowEvaluationResults() {
      console.log("8y3894ty4983t3489ty3498ty39ty");
      this.demonstrateTitle = "测评结果演示";
      this.demonstrateBtnNum = 1;
      this.demonstrateType = "测评结果演示";
      this.demonstrateImg =
        "https://ossfastmake.mustke.com/wenjuan/tupian/编组 4-1772006429746.png";
      this.showDemonstrate = true;
    },
    handleShowConsentForm() {
      this.demonstrateType = "知情同意书";
      this.showDemonstrate = true;
    },
    handleShowLogin() {
      this.demonstrateTitle = "独立登录演示";
      this.demonstrateBtnNum = 1;
      this.demonstrateType = "独立登录演示";
      this.demonstrateImg =
        "https://ossfastmake.mustke.com/qrCode/tupian/1749697119154.jpg";
      this.showDemonstrate = true;
      this.demonstrateType = "";
    },
    handleShowShareDemoPopup() {
      this.demonstrateType = "分享图演示";
      this.showDemonstrate = true;
      this.demonstrateInfo = {
        name: config.name,
        title: "问卷标题",
        btn: "进入问卷",
      };
    },
    handleDemonstrateConfirm() {
      this.showDemonstrate = false;
    },
    handleRandomQuestions() {
      this.showRandomQuestions = true;
    },
    randomQuestionsNumChange(e) {
      // 获取输入值并转换为数字
      const inputValue = parseInt(e.detail.value) || 0;
      const max = this.dataList.filter(
        (item) =>
          item.type === 1 ||
          item.type === 2 ||
          item.type === 3 ||
          item.type === 4 ||
          item.type === 22 ||
          item.type === 11 ||
          item.type === 23 ||
          item.type === 28,
      ).length;
      console.log(e, inputValue, max);
      // 限制最大值为5，同时不超过题目总数
      // const actualMax = Math.min(max, 5)
      console.log(inputValue > max);
      setTimeout(() => {
        if (inputValue > max) {
          this.randomQuestionsNum = max;
        } else {
          this.randomQuestionsNum = inputValue;
        }
      }, 10);
    },
    randomQuestionsConfirmClick() {
      const max = this.dataList.filter(
        (item) =>
          item.type === 1 ||
          item.type === 2 ||
          item.type === 3 ||
          item.type === 4 ||
          item.type === 22 ||
          item.type === 11 ||
          item.type === 23 ||
          item.type === 28,
      ).length;
      if (parseInt(this.randomQuestionsNum) > max) {
        this.randomQuestionsNum = max;
      }
      if (
        this.randomQuestionsNum === "" ||
        parseInt(this.randomQuestionsNum) === 0
      ) {
        uni.showToast({
          title: "请输入随机题目数量",
          icon: "none",
        });
        return;
      }
      this.dataObj.randomQuestionsNum = this.randomQuestionsNum;
      this.showRandomQuestions = false;
    },
    closeRandomQuestions() {
      this.showRandomQuestions = false;
    },
    handleIsKnown() {
      this.showBuyAgree = false;
      this.buyAgree = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-div {
  display: flex;
  align-items: center;
}

.switch-div p {
  font-size: 14px;
  font-weight: 400;
  color: #555a64;
}

.switch-div .el-switch {
  margin-left: 10px;
}

.add_title {
  font-size: 18px;
  display: flex;
  justify-content: space-between;
}

.demonstration {
  font-size: 14px;
  font-weight: 400;
  color: #555a64;
}

.questionnaire_box .add_control .add_btn_list .btn_item .content {
  padding: 0;
}

.item-container {
  width: 100%;
  height: calc(100% - 80px);
  padding-top: 25px;
  padding-bottom: 92px;
  overflow: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
}

.setting-item {
  height: 51px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 10px 0; */
  border-bottom: 1px solid #e7e7e7;
  transition: opacity 0.3s ease;
  will-change: transform, opacity;
  /* 防止字体加载导致的布局变化 */
  font-display: swap;
  margin-right: 20px;
}

.setting-item-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setting-item-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.setting-title {
  font-weight: 600;
  color: #4c4a56;
  font-size: 15px;
  margin-right: 6px;
  /*margin-left: 14px;*/
}

.setting-subitem {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(231, 231, 231, 0.5);
  min-width: 150px;
  transition: opacity 0.3s ease;
  will-change: transform, opacity;
  /* 防止字体加载导致的布局变化 */
  font-display: swap;
}

.setting-subtitle {
  font-weight: 600;
  color: #4c4a56;
  font-size: 14px;
  margin-right: 22px;
  flex: 1;
  /*margin-left: 14px;*/
}

.setting-link {
  color: #3a60ff;
  font-size: 14px;
  margin-left: 8px;
}

.bar-view {
  width: 4px;
  height: 15px;
  background-color: #3a60ff;
  margin-right: 10px;
  border-radius: 0 4px 4px 0;
}

.btn-div {
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}

.cancel {
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #3a60ff;
  background-color: #ffffff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.confirm {
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #fff;
  background-color: #3a60ff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.allow-times-text {
  font-size: 14px;
  color: #798497;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.allow-times-input div {
  width: calc(100% - 10px);
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  font-size: 14px;
  margin-top: 5px;
}

.allow-times-input.special {
  font-size: 12px;
  padding-right: 20px;
}

.allow-times-input.special div {
  width: 80px;
  display: inline-block;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 420px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  /* overflow-y: auto; */
}

.bg-view {
  width: 350px;
}

.body-view {
  width: 100%;
  height: 300px;
  margin-top: 5px;
  padding: 0 10px;
  box-sizing: border-box;
}

.header-view {
  width: 100%;
  // height: 118rpx;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px 14px;
  box-sizing: border-box;
  position: relative;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #e7e7e7;

  p {
    font-size: 18px;
    font-weight: 600;
    color: #2b2f36;
  }

  img {
    width: 13px;
    height: 13px;
    margin-right: 21px;
  }
}

.header-view img {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
}

.service-account {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;

  .qrcode {
    margin-top: 32px;
    width: 240px;
    height: 240px;
  }

  .text {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: center;
    color: #8e8da1;
    margin-top: 10px;
  }
}

.rechargeContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  position: relative;

  .title {
    margin-top: 25px;
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    color: #4b2e1c;
    text-align: center;
    line-height: 1;
  }

  .close {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 27px;
    right: 15px;
    cursor: pointer;
  }

  .description {
    margin-top: 12px;
    width: calc(100% - 30px);
    font-size: 14px;
    // color: #ac7c5e;
    color: #7e7e81;
    text-align: left;
  }

  .tab {
    display: flex;
    margin-top: 13px;
    width: calc(100% - 30px);
    // padding: 0 15px;
    gap: 8px;

    .item {
      flex: 1;
      flex-direction: column;
      align-items: center;
      background: #ffffff;
      border: 1px solid #f9b762;
      border-radius: 8px;
      // max-width: calc(33.33% - 8px);
      width: 95px;
      height: 130px;
      text-align: center;
      position: relative;
      overflow: hidden;
      cursor: pointer;

      &.active {
        background: linear-gradient(180deg, #fff1de, #ffdeba);

        .text {
          background: #ff7c5e;
          color: #fff;
          border: 1px solid #ff7c5e;
        }
      }

      .number {
        font-size: 16px;
        font-weight: bold;
        color: rgba(172, 124, 94, 0.98);
        margin-top: 14px;
      }

      .money {
        font-size: 21px;
        font-weight: bold;
        color: #4b2e1c;
        margin-top: 8px;
      }

      .originalPrice {
        font-size: 11px;
        color: rgba(172, 124, 94, 0.65);
        margin-top: 8px;
        text-decoration: line-through;
      }

      .text {
        width: 100%;
        font-size: 11px;
        color: #4b2e1c;
        // margin-top: 20px;
        background: #ffedd6;
        border: 1rpx solid #facb8d;
        border-radius: 0 0 8px 8px;
        text-align: center;
        // padding: 6px 0;
        position: absolute;
        bottom: 0;
      }
    }
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    width: 205px;
    height: 40px;
    background: #ff7c5e;
    border-radius: 10px;
    font-size: 15px;
    color: #ffffff;
    cursor: pointer;
  }
}

.Payment,
.emailUpload,
.Recharge,
.emailPrompt,
.emailPolicy {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background: #00000050;
}

.Payment .content,
.emailUpload .content,
.Recharge .content,
.emailPrompt .content,
.emailPolicy .content {
  width: 312px;
  height: 344px;
  background: #ffffff;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Payment .content .title,
.emailUpload .content .title,
.Recharge .content .title,
.emailPrompt .content .title,
.emailPolicy .content .title {
  height: 50px;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: Bold;
  color: #333333;
  position: relative;
  margin-bottom: 0;
}

.Payment .content .title .dialogClose,
.emailUpload .content .title .dialogClose,
.Recharge .content .title .dialogClose,
.emailPrompt .content .title .dialogClose,
.emailPolicy .content .title .dialogClose {
  top: 15px;
  right: 15px;
}

.Payment .content {
  width: 440px;
  height: auto;
  padding-bottom: 20px;
  background: #ffffff;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Payment .content .region {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.Payment .content .region .item {
  font-size: 12px;
  font-weight: Regular;
  color: rgba(58, 58, 60, 0.98);
}

.Payment .content .region .item span {
  font-size: 18px;
  font-weight: Regular;
  color: rgba(247, 59, 66, 0.98);
}

.Payment .content .code {
  padding: 15px;
}

.Payment .code {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.Payment .code .brand {
  width: 120px;
  height: auto;
}

.Payment .code .image {
  width: 180px;
  height: 180px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  /* position: absolute;
	bottom: 34px;
	left: 20px; */
}

.Payment .code span {
  font-size: 16px;
}

.dialogClose {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #8690a2;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.dialogClose::before,
.dialogClose::after {
  display: block;
  content: "";
  width: 8px;
  height: 1px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}

.dialogClose::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.demoButton {
  width: 42px;
  height: 20px;
  line-height: 20px;
  background: #9ab3ec;
  border-radius: 15px;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.setting-icon {
  width: 5px;
  height: 5px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: rotate(-45deg);
  margin-left: 3px;
}

/*************触发完成条件设置-开始************/
.completion-container {
  .bg-view {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .header-view {
    width: 100%;
    height: 59px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7e7e7;
  }

  .random-container {
    margin-top: 20px;
    width: 100%;
    max-height: 275px;
    padding-bottom: 20px;
    //box-sizing: border-box;
    //overflow: hidden;
    //overflow-y: auto;
  }

  .left-item {
    width: 100%;
    //height: 111rpx;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //border-bottom: 1px solid #F0F0F0;
    //  padding: 24rpx 0;

    .title {
      font-size: 15px;
      font-weight: 500;
      color: #4c4a56;
      // max-width: 300rpx;
      overflow: hidden;
      //margin-left: 24rpx;
    }

    .desc {
      font-size: 14px;
      font-weight: 400;
      color: #3a60ff;
      display: flex;
      align-items: center;
      flex-grow: 1;
      text-align: right;
      justify-content: flex-end;
      margin-left: 15px;
      white-space: nowrap;
    }
  }

  .right-item {
    width: 50%;
    display: flex;
    align-items: center;
    margin-top: 15px;

    .circle {
      //width: 31rpx;
      //height: 31rpx;
      padding: 3px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #d0d0d0;
    }

    .point {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    .title {
      font-size: 15px;
      font-weight: 500;
      color: #4c4a56;
      max-width: 150px;
      overflow: hidden;
      margin-left: 12px;
    }
  }

  .btn-view {
    //@include btn_view();
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    //bottom: calc(constant(safe-area-inset-bottom));
    //bottom: env(safe-area-inset-bottom);
  }

  .cancel {
    width: 159px;
    height: 35px;
    line-height: 35px;
    border-radius: 35px;
    border: 1px solid #3a60ff;
    background: #ffffff;
    color: #3a60ff;
    font-weight: 600;
    text-align: center;
    font-size: 16px;
  }

  .confirm {
    width: 159px;
    height: 35px;
    line-height: 35px;
    border-radius: 35px;
    border: 1px solid #3a60ff;
    background: #3a60ff;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
    font-size: 16px;
  }
}
/*************触发完成条件设置-结束************/

.agree-view {
  display: flex;
  align-items: center;
  padding: 0 5px;
  margin-top: 15px;

  .agree-text1 {
    font-size: 13px;
    color: #4b2e1c;
    margin-left: 5px;
  }

  .agree-text2 {
    font-size: 13px;
    color: #1877ff;
    cursor: pointer;
  }
}

.agree-content {
  width: 100%;
  padding: 8px 15px;
  box-sizing: border-box;

  .agree-title {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #3c4252;
    line-height: 22px;
    margin-top: 15px;
  }

  .agree-desc {
    font-size: 15px;
    font-weight: 400;
    text-align: left;
    color: #3c4252;
    line-height: 21px;
    margin-top: 8px;
  }
}

.agree-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  width: 118px;
  height: 41px;
  background: #3a60ff;
  border-radius: 5px;
  font-size: 15px;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EditSetting/index.vue